module.exports = __webpack_public_path__ + "static/media/gallery_04.feb8ca56.jpg";